import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { AccountContentTitle } from "../AccountContentTitle";
import { Pagination } from "../Pagination";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.AddressListDocumentTemplate> & {
    // The brand button-modifier class for the "Add a new address" CTA. Defaults
    // to the platform value; a site whose legacy address book used a different
    // brand modifier (e.g. toppers' button--ming) overrides it.
    buttonModifierClass?: string;
};

export const AddressListBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        add_address_url,
        add_address_label,
        address_header_label,
        empty_message,
        addresses,
        pagination,
        buttonModifierClass = "button--lochmara-blue",
    } = props;
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <AccountContentTitle
                    contentTitle={content_title}
                    phoneDisplay={phone_display}
                    phoneHref={phone_href}
                />

                <div className="content__copy--full-width">
                    <div className="address-list-table">
                        <a
                            href={add_address_url}
                            className={`button ${buttonModifierClass}`}
                        >
                            {add_address_label}
                        </a>
                        {addresses.length > 0 ? (
                            <>
                                <table className="table table-striped table-bordered">
                                    <tbody>
                                        <tr>
                                            <th>{address_header_label}</th>
                                            <th></th>
                                        </tr>
                                        {addresses.map((address, i) => (
                                            <tr key={i}>
                                                <td>
                                                    {address.is_default_for_shipping && (
                                                        <span className="label label-success">
                                                            {
                                                                address.default_shipping_label
                                                            }
                                                        </span>
                                                    )}
                                                    {address.is_default_for_billing && (
                                                        <span className="label label-info">
                                                            {
                                                                address.default_billing_label
                                                            }
                                                        </span>
                                                    )}
                                                    <address>
                                                        {address.fields.map(
                                                            (field, j) => (
                                                                <React.Fragment
                                                                    key={j}
                                                                >
                                                                    {field}
                                                                    <br />
                                                                </React.Fragment>
                                                            ),
                                                        )}
                                                    </address>
                                                </td>
                                                <td>
                                                    <div className="btn-group">
                                                        <a
                                                            className="btn btn-default"
                                                            href={
                                                                address.edit_url
                                                            }
                                                        >
                                                            {address.edit_label}
                                                        </a>
                                                        <button
                                                            className="btn btn-default dropdown-toggle"
                                                            data-toggle="dropdown"
                                                        >
                                                            <span className="caret"></span>
                                                        </button>
                                                        <ul className="dropdown-menu">
                                                            <li>
                                                                <a
                                                                    href={
                                                                        address.delete_url
                                                                    }
                                                                >
                                                                    {
                                                                        address.delete_label
                                                                    }
                                                                </a>
                                                            </li>
                                                            {address.set_default_shipping_url && (
                                                                <li>
                                                                    <a
                                                                        href={
                                                                            address.set_default_shipping_url
                                                                        }
                                                                    >
                                                                        {
                                                                            address.set_default_shipping_label
                                                                        }
                                                                    </a>
                                                                </li>
                                                            )}
                                                            {address.set_default_billing_url && (
                                                                <li>
                                                                    <a
                                                                        href={
                                                                            address.set_default_billing_url
                                                                        }
                                                                    >
                                                                        {
                                                                            address.set_default_billing_label
                                                                        }
                                                                    </a>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {pagination && <Pagination data={pagination} />}
                            </>
                        ) : (
                            <p>{empty_message}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
